var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPauseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  d: "M12 1.2c5.964 0 10.8 4.836 10.8 10.8S17.964 22.8 12 22.8 1.2 17.964 1.2 12 6.036 1.2 12 1.2m-1.98 5.04H6.78a.36.36 0 0 0-.36.36v10.8c0 .199.161.36.36.36h3.24a.36.36 0 0 0 .36-.36V6.6a.36.36 0 0 0-.36-.36m7.2 0h-3.24a.36.36 0 0 0-.36.36v10.8c0 .199.161.36.36.36h3.24a.36.36 0 0 0 .36-.36V6.6a.36.36 0 0 0-.36-.36"
}))));
export default SvgPauseIcon;